// Records the current product in this device's browsing footprint: [{ h: handle, t: viewed-at ms }], newest first, capped.
const STORAGE_KEY = 'hcr:recently-viewed';
const MAX_ITEMS = 60;

class RecentlyViewedTracker extends HTMLElement {
  connectedCallback() {
    const handle = this.dataset.handle;
    if (!handle) return;
    try {
      const stored = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      const list = (Array.isArray(stored) ? stored : [])
        .map((item) => (typeof item === 'string' ? { h: item, t: 0 } : item))
        .filter((item) => item && typeof item.h === 'string' && item.h !== handle);
      list.unshift({ h: handle, t: Date.now() });
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list.slice(0, MAX_ITEMS)));
    } catch (_) {
      // Storage can be unavailable (private mode, blocked cookies); the footprint is a nice-to-have.
    }
  }
}

if (!customElements.get('s-recently-viewed-tracker')) customElements.define('s-recently-viewed-tracker', RecentlyViewedTracker);
